import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getCollectibleLabel, getProgram } from "../program";
import { selectLoyaltyProgramDetails } from "../selectors";

/**
 * What the active programme calls its points, ready to drop into copy.
 *
 * ```ts
 * const collectibleLabel = useCollectibleLabel();
 * collectibleLabel(points)                     // "Point" / "Points" by count
 * collectibleLabel()                           // plural
 * collectibleLabel(5, TEXT_TRANSFORM.UPPERCASE)
 * ```
 *
 * Stable across renders while the programme's naming is unchanged, so it is safe in a dependency
 * array.
 */
export function useCollectibleLabel() {
  const programDetails = useSelector(selectLoyaltyProgramDetails);
  const program = getProgram(programDetails);
  const { collectibleName, collectibleNamePlural } = program ?? {};

  return useCallback(
    (count?: number, transform?: string) =>
      getCollectibleLabel({ collectibleName, collectibleNamePlural }, count, transform),
    [collectibleName, collectibleNamePlural],
  );
}
